import { Checkbox, Form } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';
import DynamicAds, { KEY_ADS_TYPE } from '../ads/dynamic-ads';

const WidgetSuggest = ({ child, title, data, showCheckbox, showAds, button, recaptchaBox }) => {
  return (
    <>
      {showCheckbox &&
        <CheckboxComp>
          <Form.Item
            className='checkbox-agreement'
            name='agreement'
            valuePropName='checked'
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('กรุณา ยอมรับนโยบายความเป็นส่วนตัวและเงื่อนไขกิจกรรม'))
              }
            ]}
          >
            <Checkbox> <p> <span className='agree'> ยอมรับนโยบายความเป็นส่วนตัวและเงื่อนไขกิจกรรม </span> <a href={`${WEB_URL}/privacy-policy`} target='_blank' aria-label='อ่านเพิ่มเติม'> อ่านเพิ่มเติม </a></p> </Checkbox>
          </Form.Item>
        </CheckboxComp>}
      {child}
      {!_.isEmpty(data) && (
        <Container >
          <Border>
            <div className='text-suggest'>
              <div className='flex-container'>
                <div className='suggest-wrapper'>
                  <>
                    <p> {title || 'หมายเหตุ :'} </p>
                    <ul>
                      {_.isArray(data) &&
                        data.map((el, i) => !_.isEmpty(el?.value) && <li key={i}>{el?.value}</li>)}
                    </ul>
                  </>
                </div>
                {showAds && <DynamicAds className='ads-sticky' type={KEY_ADS_TYPE.STICKY} section='voter' adsName='sticky-1' />} </div>

            </div>
          </Border>

        </Container>
      )}

    </>
  );
};

const CheckboxComp = styled.div`
display: flex;
width: 100%;
justify-content: center;
align-items: center;
background-color: #FFFFFFFF;
margin: 20px auto;
padding: 0 20px;
max-width: 500px;
border: 2px solid #050B09;
border-radius: 18px;
a {
  color: #fff;
  font-size: 16px;
  text-decoration: underline;
  padding-left: 5px;
  &:hover {
    color: #fdc773;
  }
}
.agree {
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
display: block;
  }
}
.checkbox-agreement {
  margin: 0;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  line-height: 1.25;
  padding: 15px;
}
p {
  display: flex;
  @media (max-width: 768px) {
    display: block;
    a {
      padding-left: 0;
    }
    span{
      font-size: 16px;
    }

  }
}
span {
  color: #fdc773;
  font-size: 18px;
  font-weight: 600;
}`;

const Container = styled.div`
  display: block;
  text-align: start;
  width: 100%;
  margin: 30px auto 0 auto;
  border-radius: 27px;
  padding: 5px;
  margin: 40px 0;
       background:  rgb(36 31 35) ;
        background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);

ul {
  padding-left: 20px;
}
  ul li {
    list-style-type: disc;
    list-style-position: inside;
    margin-bottom: 4px;
    @media (max-width: 475px) {
      list-style-position: outside;
    }

  }
  @media (max-width: 768px) {
    margin: 30px auto;
  }

  `;
const Border = styled.div`
    background: #FFF;
    border-radius: 25px;
    .text-suggest  {
        width: 100%;
        display: block;
        color: #050B09;
        font-weight: 500;
        font-size: 20px;
        line-height: 1.85;
        padding: 15px 25px;
        letter-spacing: 0.25px;
        
        .flex-container {
          display: flex;
          flex-direction: row;
          @media (max-width: 992px) {
            flex-direction: column;
            overflow: hidden;
          }
          .suggest-wrapper {
            width: 100%;
            p {
              background: linear-gradient(90deg, #ab8000 0%, #f2ca46 100%);
              /* หรือถ้าต้องการใช้กับตัวอักษร */
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              font-size: 30px;
              font-weight: 600;
              @media (max-width: 475px) {
                font-size: 22px;
                padding-bottom: 10px;
            }
            }
            @media (max-width: 992px) {
                width: 100%;
            }
          }
          .ads-sticky {
            margin: auto;
            @media (max-width: 992px) {
              margin: 20px auto;
            }
          }
        }
        span {
          letter-spacing: 2px;
          color: rgba(230,187,127,0.72);
      }
    }
    @media(max-width:475px){
        .text-suggest {
          font-size: 16px;
          line-height: 1.5;
        }
    }

`;

export default WidgetSuggest;
